export const SERVER = "https://static.plan-b.archi/";